import { render, staticRenderFns } from "./FormulaSel.vue?vue&type=template&id=388eb83f&"
import script from "./FormulaSel.vue?vue&type=script&lang=js&"
export * from "./FormulaSel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports